import { jsx, Fragment } from 'react/jsx-runtime';
import moment from 'moment';

function formatDate({ value, format, locale = 'en' }) {
    const d = moment(value).locale(locale);
    if (format) {
        if (d[format])
            return d[format]();
        return d.format(format);
    }
    return d.toString();
}
function DateTime({ value = new Date(), format, locale }) {
    return jsx(Fragment, { children: formatDate({ value, format, locale }) });
}

export { DateTime, formatDate };
